import { atom, selector } from 'recoil'

export const pageState = atom({
  key: 'smtpplusListPageState',
  default: {
    fetchingResults: false
  }
})

export const pageErrorState = atom({
  key: 'smtpplusListPageErrorState',
  default: {
    error: undefined,
    severity: 'danger'
  }
})

export const loadingState = selector({
  key: 'smtpplusListLoadingState',
  get: ({ get }) => {
    const { fetchingResults } = get(pageState)
    return [fetchingResults].some(value => value)
  }
})

export const deliverabilityIndexState = atom({
  key: 'smtpplus_deliverabilityIndexState',
  default: {
    loaded: false,
    loading: false,
    ScoreData: { Score: -1 },
    UpdateDate: null,
    CampaignNumber: 0,
    DeliverabilityPlus: false,
    AlertsData: {
      Sender: false,
      Volume: false,
      BrandShield: false,
      Engagement: false
    },
    StatusBarData: {
      Sender: 0,
      Volume: 0,
      Engagement: 0
    }
  }
})
